import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 40px;
  border-radius: 8px;
  margin-bottom: 10px;
`;
